import { BaseComponent } from '../base-component'
import { getTemplateContent } from '../../utils/dom'
import { $el } from 'src/scripts/utils/utils'

const TEMPLATE_SELECTOR = '[data-share-custom-template]'
const DEFAULT_TEMPLATE_SELECTOR = '[data-share-system-default-template]'

export class ShareWrapper extends BaseComponent {
  mountComponent(): void {
    this.init()
  }

  init(): void {
    const customTemplate = $el(TEMPLATE_SELECTOR, this)
    const systemDefaultTemplate = $el(DEFAULT_TEMPLATE_SELECTOR, this)
    const template = navigator.share ? systemDefaultTemplate : customTemplate

    this.replaceChildren(getTemplateContent(template))
  }
}
